import React, { FC } from "react";
import classNames from "classnames";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { CircularProgress } from "material-ui";
import { DATATEST } from "constants/integration";

const DEFAULT_SIZE = 40;

export const InlineLoading: FC<{ className?: string; margin?: string; size?: number }> = ({
    margin,
    className,
    size,
}) => {
    const classes = useLoadingStyles({ margin });
    return (
        <div className={classNames(className, classes.root)} data-test={DATATEST.INLINE_LOADING}>
            <CircularProgress size={size ?? DEFAULT_SIZE} />
        </div>
    );
};

export const ContentLoading: FC<{ className?: string; size?: number }> = ({ className, size }) => {
    const classes = useContentStyles({});
    return <InlineLoading className={classNames(classes.root, className)} size={size} />;
};

const useLoadingStyles = makeStyles<Theme, { margin?: string }>({
    root: ({ margin }) => ({
        display: "flex",
        justifyContent: "center",
        width: "auto",
        margin: margin || 0,
    }),
});

const useContentStyles = makeStyles({
    root: {
        position: "absolute",
        height: "100%",
        top: 0,
        alignItems: "center",
        width: "100%",
        background: "rgba(245, 245, 245, 0.5)", // theme.palette.disabledButtonColor suitable for IE
    },
});
